<template>
  <div class="timeline-container">
    <!-- <timeAxis :date-arr="dateArr" :time-axis-length="timeAxisLength" :play-width="playWidth" /> -->
    <div class="content">
      <div class="buttons">
        <div class="pre position"  @click="pre">
          <img src="../../assets/png/last.png"/>
        </div>
        <div class="play position" @click="run">
          <img v-if="isPlay" src="../../assets/png/play.png" />
          <img v-else src="../../assets/png/pause.png" />
        </div>
        <div class="next position" @click="next">
          <img src="../../assets/png/next.png"/>
        </div>
      </div>
      <div class="axis">
        <div v-for="item in dateArr" :key="item.index" class="time-block" :style="{width: (100 / timeAxisLength) + '%' }">
          <!--刻度-->
          <div class="line">
            <div v-for="count in 4" :key="count.index" class="separate-line" />
          </div>
          <!--小时-->
          <div class="num">
            <div v-for="count2 in 4" :key="count2.index" class="separate-num">{{ 6 * count2 &lt; 10 ? '0' + 6*count2 : 6*count2 }}</div>
          </div>
          <!--日期-->
          <div class="date"><span>{{ item }}</span></div>
        </div>
        <div ref="lineWidth" class="progress" @click="proClick($event)">
          <div class="not-played" />
          <div class="played" :style="{width: playWidth+'%'}" />
        </div>
      </div>
    </div>

    <div class="legend-box">
      <div v-if="isWind">
        <div class="legend-icon">
          <div class="bgColor-wind" />
          <div class="ins">
            <div class="span-no-sea">0</div>
            <div class="span-no-sea">5</div>
            <div class="span-no-sea">10</div>
            <div class="span-no-sea">20</div>
            <div class="span-no-sea">30</div>
            <div class="span-no-sea">40</div>
            <div class="span-no-sea">60</div>
          </div>
        </div>
        <div class="legend-title">风 (kt)</div>
      </div>
      <div v-else-if="isCurrent">
        <div class="legend-icon">
          <div class="bgColor-current" />
          <div class="ins">
            <div class="span-no-sea">0</div>
            <div class="span-no-sea">0.4</div>
            <div class="span-no-sea">0.8</div>
            <div class="span-no-sea">1.6</div>
            <div class="span-no-sea">2</div>
            <div class="span-no-sea">3.2</div>
          </div>
        </div>
        <div class="legend-title">洋流 (kt)</div>
      </div>
      <div v-else>
        <div class="legend-icon">
          <div class="bgColor-wave" />
          <div class="ins">
            <div class="span-no-waves">0</div>
            <div class="span-no-waves">2</div>
            <div class="span-no-waves">4</div>
            <div class="span-no-waves">6</div>
            <div class="span-no-waves">8</div>
            <div class="span-no-waves">10</div>
            <div class="span-no-waves">12</div>
          </div>
        </div>
        <div class="legend-title">海浪 (m)</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
// import _ from 'lodash'
export default {
  name: 'BottomItem',
  filters: {
  },
  props: {
    // timestamp: {
    //   type: Number,
    //   default: 0
    // }
  },
  data() {
    return {
      forecastDate: moment(new Date()).format('YYYYMMDD'), // 日常（预报）模式日期
      timeAxisLength: 7,
      timer: null,
      isOpenTyphoon: false,
      isPlay: false,
      dateArr: [], // 日期轴数组（默认是今天明天），后向前向切换日期选择时候，就变成选择的那一天和下一天
      grid: 0, // 时间轴格点数
      initedGrid: 0, //初始的grid
      initedPlayWidth: 0, 
      daysApart: 0, // 与今天相隔几天（默认为0）
      i: 0, // title走到第二个日期
      t: 0, // title走到第二个日期对应的时刻
      timeArr: [],
      playWidth: 0,
      gridUnit: 1 //刻度大小  1： 1小时为一个刻度  3： 3小时一个刻度
    }
  },
  computed: {
    ...mapGetters(['showWeatherIcons', 'timeGrid', 'isWind', 'isCurrent', 'isWaves']),
  },
  watch: {
    forecastDate(val) {
      if (val) {
        this.countDay(moment(val).format('YYYY-MM-DD'))
        this.dateArr = []
        this.getDateArr()
        this.timeArr = []
        this.getTimeArr()
        this.getBeijingTimeArr()
      }
    },
    timeGrid: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.updateGrid()
        }
      },
      deep: true
    }
  },
  mounted() {
    this.updateTime()
    this.updateGrid()

    setInterval(() => {
       this.updateTime()
    }, 10 * 60 * 1000)

    // setTimeout(() => {
    //   const elTimeBlock = document.getElementsByClassName('time-block')
    //   elTimeBlock[elTimeBlock.length - 1].style.borderRight = '1px solid #999'

    //   const el = document.getElementsByClassName('timeline-container')[0]
    //   el.style.width = '50%'
    //   el.style.bottom = '0px'
    //   el.style.left = '25%'
    // }, 200)
  },
  methods: {
    ...mapActions(['SET_TIME_GRID', 'SET_IS_PLAY']),
    updateTime() {
      const currentHour = new Date().getHours()
      this.SET_TIME_GRID(currentHour)
      this.getInitedGrid()
      this.getDateArr()
      this.getTimeArr()
      this.getBeijingTimeArr()
      this.t = new Date().getHours()
    },
    updateGrid() {
      const currentNo = Math.floor(this.timeGrid / this.gridUnit)
      this.grid = currentNo * this.gridUnit
      this.playWidth = this.grid / 168 * 100
    },
    getInitedGrid() {
      const currentNo = Math.floor(this.timeGrid / this.gridUnit)
      this.initedGrid = currentNo * this.gridUnit
      this.initedPlayWidth = this.initedGrid / 168 * 100
    },
    resetTimeGrid() {
      this.grid = this.initedGrid
      this.playWidth = this.initedPlayWidth
    },
    run() {
      if (this.isPlay === true) {
        this.isPlay = false
        this.stop()
      } else {
        this.isPlay = true
        this.play()
      }
    },
    next() {
      if (this.grid >= 168) {
        this.$message({
          message: '已经到顶啦!',
          type: 'warning'
        })
        return false
      } else {
        const _currentNo = Math.floor(this.grid / this.gridUnit)
        this.grid = _currentNo * this.gridUnit + this.gridUnit
      }
      this.SET_TIME_GRID(this.grid)
    },
    pre() {
      if (this.grid <= 0) {
        this.$message({
          message: '已经到底啦!',
          type: 'warning'
        })
        return false
      } else {
        const currentNo = Math.floor(this.grid / this.gridUnit)
        this.grid = currentNo * this.gridUnit - this.gridUnit
      }
      this.SET_TIME_GRID(this.grid)
    },
    play() {
      this.SET_IS_PLAY(true)
      this.timer = setInterval(() => {
        const currentNo = Math.floor(this.grid / this.gridUnit)
        this.grid = currentNo * this.gridUnit + this.gridUnit
        this.i = parseInt(this.grid / 24)
        this.t = (this.grid % 24) * this.gridUnit
        /** 播放结束后，进度条初始化**/
        if (this.grid > this.timeAxisLength * 24) {
          //this.grid = this.timeAxisLength * 24
          this.resetTimeGrid()
          this.isPlay = false
          this.stop()
          //return
        }
        this.SET_TIME_GRID(this.grid)
      }, 1.5 * 1000)
    },
    stop() {
      this.SET_IS_PLAY(false)
      clearInterval(this.timer)
    },
    getDate(n) { // 获取n天后的日期，n = 0就是今天，n = 1明天，n = -1昨天
      const now = new Date()
      now.setDate(now.getDate() + n) // 获取n天后的日期
      // let y = now.getFullYear()
      const m = now.getMonth() + 1
      const d = now.getDate()
      // return y + '年' + m + '月' + d + '日'
      return m + '月' + d + '日'
    },
    getDate2(n) {
      // 获取n天后的日期，n = 0就是今天，n = 1明天，n = -1昨天
      // 另外一种日期格式 20210120
      const now = new Date()
      now.setDate(now.getDate() + n) // 获取n天后的日期
      const y = now.getFullYear()
      const m = now.getMonth() + 1
      const d = now.getDate()
      const nowDate = y.toString() + (m < 10 ? '0' + m : m).toString() + (d < 10 ? '0' + d : d).toString()
      return nowDate
    },
    getDate3(n) {
      const now = new Date()
      now.setDate(now.getDate() + n) // 获取n天后的日期
      const y = now.getFullYear()
      const m = now.getMonth() + 1
      const d = now.getDate()
      const nowDate = y.toString() + '-' + (m < 10 ? '0' + m : m).toString() + '-' + (d < 10 ? '0' + d : d).toString()
      return nowDate
    },
    countDay(date) { // 计算与今天相差几天 date必须是2021-04-08格式
      const date1 = new Date(date)
      const y = new Date().getFullYear()
      const m = new Date().getMonth() + 1
      const d = new Date().getDate()
      const t = y.toString() + '-' + (m < 10 ? '0' + m : m).toString() + '-' + (d < 10 ? '0' + d : d).toString()
      const date2 = new Date(t)
      const result = date1.getTime() - date2.getTime()
      this.daysApart = Math.round(result / (24 * 3600 * 1000))
      return this.daysApart
    },
    getDateArr() {
      for (let i = 0; i < this.timeAxisLength; i++) {
        this.dateArr.push(this.getDate(this.daysApart + i))
      }
      // this.$store.commit('dashboard/SET_DATEARR', this.dateArr)
      return this.dateArr
    },
    getTimeArr() {
      // 时间轴格点变化，对应的 时间路径类如 2021012012，用来拼接svg图片路径
      for (let i = this.daysApart - 1; i < this.timeAxisLength; i++) {
        const t = this.getDate2(i)
        for (let j = 0; j < 24; j++) {
          this.timeArr.push(t + (j < 10 ? '0' + j : j))
        }
      }
      const n = 24 * this.timeAxisLength + 1 + 16
      this.timeArr = this.timeArr.slice(16, n)
      // this.$store.commit('dashboard/SET_TIMEDETAILARR', this.timeArr)
    },
    getBeijingTimeArr() {
      // 北京时间数组 2021-04-14 12：00 格式
      var beijingTimeArr = []
      for (let i = this.daysApart; i < this.daysApart + 2; i++) {
        const t = this.getDate3(i)
        for (let j = 0; j < 24; j++) {
          beijingTimeArr.push(t + ' ' + (j < 10 ? '0' + j : j) + ':00:00')
        }
        // beijingTimeArr = beijingTimeArr.slice(0, 49)
      }
      // this.$store.commit('dashboard/SET_BEIJINGTIMEARR', beijingTimeArr)
    },
    proClick($event) {
     const oldGrid = this.grid
      const lineWidth = this.$refs.lineWidth.clientWidth // 时间轴整个width
      const tWidth = $event.offsetX // 鼠标点击的width
      const cellWidth = lineWidth / (24 * this.timeAxisLength) // 每个小格子的width
      const cells = Math.round(tWidth / cellWidth) // 鼠标点击width是多少格子

      this.i = parseInt(cells / 24)
      this.t = (cells % 24)
      this.grid = Math.floor(cells / this.gridUnit) * this.gridUnit
      if (oldGrid !== this.grid) {
        this.SET_TIME_GRID(this.grid)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @media screen and (max-width: 1500px) {
    .timeline-container {
      left: 360px;
      right: 360px;
      width: calc(100% - 720px);
    }
  }

@media screen and (min-width: 1501px) {
  .timeline-container {
    left: 25%;
    width: 50%;
    }
  }

  @media screen and (min-width: 2561px) {
    .timeline-container {
    left: 21%;
    width: 58%;
    }
}

.timeline-container {
  position: absolute;
  bottom: 0px;
  height: 38px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(0, 0, 0, 0.4);

  .content {
    backdrop-filter: blur(2px);
    width: 80%;
    height: 38px;
    display: flex;
    .buttons {
      padding: 0 5px;
      height: 100%;
      width: 15%;

      .position {
        /* font-size: 15px; */
        height: 100%;
        line-height: 36px;
        float: left;
        vertical-align: middle;
        text-align: center;
        cursor: pointer;
      }
      img{
        height: 24px;
        width: 24px;
        margin-top: 5px;
      }
      .pre {
        width: 30%;
      }
      .play {
        width: 40%;
        /* font-size: 20px !important;
        line-height: 37px; */
      }
      .next {
        width: 30%;
      }
      .not-allow{
       cursor: not-allowed;
      }
    }
    .axis {
      width: 85%;
      height: 100%;
      .time-block {
        float: left;
        height: 100%;
        border-left: 1px solid #999;
        box-sizing: border-box;
        .line {
          height: 12px;
          width: 100%;
          box-sizing: border-box;
          .separate-line {
            width: 25%;
            border-right: 1px solid #999;
            box-sizing: border-box;
            float: left;
            height: 10px;
            /*border-color: #999;*/
          }
          .separate-line:last-child {
            border-right: none;
          }
          .not-allow{
           cursor: not-allowed;
          }
        }
        .num {
          width: 100%;
          height: 12px;
          box-sizing: border-box;
          position: relative;
          top: -2px;
          color: rgba(255, 255, 255, 0.8);
          .separate-num {
            float: left;
            width: 25%;
            font-size: 12px;
            transform: scale(0.8);
            text-align: right;
            position: relative;
            left: 8px;
          }
          .separate-num:last-child {
            display: none;
          }
        }
        .date {
          text-align: center;
          font-size: 12px;
          height: 18px;
          width: 100%;
          line-height: 18px;
          white-space: nowrap;
          overflow: hidden;
          position: relative;
          top: -5px;
          color: #fff;
        }
      }
      .time-block:last-child {
        border-right: 1px solid #999;
      }
      .progress {
        width: 100%;
        height: 8px;
        position: relative;
        top: 0;
        cursor: pointer;
        border-top-right-radius: 4px;
        .not-played {
          background: #ffffff;
          opacity: 0.15;
          cursor: pointer;
          width: 100%;
          height: 8px;
          // border-top-right-radius: 4px;
        }
        .played {
          position: relative;
          top: -8px;
          background-color: #3d6fff;
          width: 100%;
          height: 8px;
        }
        .not-allow{
           cursor: not-allowed;
          }
      }
      .main-timecode {
        font-size: 13px;
        position: relative;
        /*top: -2.7em;*/
        top: -40px;
        color: #fff;
        .box {
          /*cursor: grab;*/
          position: absolute;
          background-color: #3d6fff;
          height: 1.8em;
          line-height: 1.8em;
          box-sizing: border-box;
          padding: 0 0.8em;
          white-space: nowrap;
          text-align: center;
          margin-left: -66px;
          //transition: all 1s linear; // 进度条动画效果
          //display: table-cell;
          //vertical-align: middle;
          border-radius: 0.5em;
          box-shadow: 0 0 4px 0 black;
        }
        .box::before {
          top: 100%;
          left: 60px;
          border: solid transparent;
          content: " ";
          height: 0;
          width: 0;
          position: absolute;
          border-top-color: rgb(0, 153, 255);
          border-width: 0.5em;
        }
      }
    }
  }

  .svg-icon {
    width: 1.5em;
    height: 1.5em;
    vertical-align: -0.55em;
    fill: #ffffff;
    overflow: hidden;
  }

  .legend-box {
    width: 20%;
    position: relative;
    top: -2px;
    right: 6px;
    align-self: flex-end;
    text-align: center;
    .legend-icon {
      height: 24px;
      width: 100%;
      padding-left: 6px;
      padding-top: 2px;
      .bgColor-wind {
        background-image: linear-gradient(
          to right,
          rgb(98, 113, 184),
          rgb(61, 110, 163),
          rgb(74, 148, 170),
          rgb(74, 146, 148),
          rgb(77, 142, 124),
          rgb(76, 164, 76),
          rgb(103, 164, 54),
          rgb(162, 135, 64),
          rgb(162, 109, 92),
          rgb(141, 63, 92),
          rgb(151, 75, 145),
          rgb(95, 100, 160),
          rgb(91, 136, 161),
          rgb(63, 110, 164)
        );
        height: 8px;
      }

      .bgColor-wave {
        background-image: linear-gradient(
          to right,
          rgb(50, 158, 186),
          rgb(57, 61, 143),
          rgb(205, 91, 209),
          rgb(146, 15, 92),
          rgb(163, 44, 8),
          rgb(128, 13, 23),
          rgb(30, 3, 4),
          rgb(30, 3, 4)
        );
        height: 8px;
      }
      .bgColor-current {
        background-image: linear-gradient(
          to right,
          #4a58a5,
          #4a9183,
          #3aa33a,
          #a59d3b,
          #b3903f,
          #914255,
          #82529f,
          #506e9d,
          #568d99,
          #809499,
          #9b9b9b
        );
        height: 8px;
      }
      .ins {
        font-size: 10px;
        /* font-weight: bold; */
        color: rgba(255, 255, 255, 1);
        line-height: 14px;
        .span-no-waves {
          width: 16%;
          text-align: left;
          float: left;
        }
        .span-no-sea{
          width: 14%;
          text-align: left;
          float: left;
        }
      }
    }
    .legend-title {
      height: 12px;
      font-size: 11px;
      font-weight: 500;
      color: #ffffff;
      line-height: 12px;
    }
  }
}
</style>
